import React from "react";

const Button = props => {
    let className = props.className ? "cdx-btn " + props.className : "cdx-btn";

    return (<button {...props} className={className}>{props.children}</button >);
};
export default Button;